var map = {
	"./bell.svg": 151,
	"./bondhushava.svg": 152,
	"./bookmark-outline.svg": 153,
	"./close.svg": 154,
	"./comments-outline.svg": 155,
	"./envelope.svg": 156,
	"./fb-blue.svg": 157,
	"./fb-whitebg.svg": 158,
	"./fb.svg": 159,
	"./gallery-whitebg.svg": 160,
	"./google-play.svg": 161,
	"./protichinta.svg": 162,
	"./search.svg": 163,
	"./twitter-whitebg.svg": 164,
	"./video-whitebg.svg": 165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 150;